export default "/images/minimize-2.svg?2e1032d6608649e8d33927df171d89df";